export interface ClauseParentPlaybookDto {
  id: string;
  label: string;
  clausesCount?: number;
  documentType?: number;
  positionId?: number;
  languageId?: number;
}

export interface ClauseDto {
  id?: number;
  uniqueId?: string;
  name: string;
  languageId: number;
  mostDesiredOptionText: string;
  fallbackOptionText: string;
  unacceptableOptionText: string;
  keyTerms?: string;
  documentTypes: number[];
  positions: number[];
  createdAt?: string;
  lastModifiedAt?: string;
  parentPlaybooks?: ClauseParentPlaybookDto[];
  playbooksCount?: number;
  isShared?: boolean;
}

export interface CreateClauseDto extends Omit<ClauseDto, 'documentTypes' | 'positions'> {
  documentTypes?: number[];
  positions?: number[];
}

export interface UpdateClauseDto extends Omit<ClauseDto, 'documentTypes' | 'positions'> {
  documentTypes?: number[];
  positions?: number[];
}

export interface GetClauseDto extends ClauseDto {
  id: number;
  uniqueId: string;
  createdAt: string;
  lastModifiedAt: string;
  parentPlaybooks: ClauseParentPlaybookDto[];
  playbooksCount: number;
  isShared: boolean;
}

export interface BatchUpdateClauseDto {
  id: string;
  documentTypes: number[];
  positions: number[];
  languageId: number;
}

export interface ClausesSearchModel {
  clauseName?: string;
  playbook?: string[] | null;
  documentType?: number[];
  position?: number[];
  languageId?: number[];
}

export interface ClauseDetailsTriggerModel {
  uniqueId: string;
  clauseName?: string;
  focusField?: ClauseDetailsField;
}

export enum ClauseDetailsField {
  ClauseName = 'clauseName',
  Language = 'languageId',
  MostDesiredOption = 'mostDesiredOptionText',
  FallbackOption = 'fallbackOptionText',
  UnacceptableOption = 'unacceptableOptionText',
  DocumentTypes = 'documentTypes',
  Positions = 'positions',
  Playbooks = 'playbooks',
}
